<div class="browser-compatibility-error">
	<mat-icon>error</mat-icon>
	<h3>
		{{ 'browser-compatibility.message' | translate }}
	</h3>
	<p>
		{{ 'browser-compatibility.error' | translate }}
	</p>
</div>
